
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { store } from "../../storeOS";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-os-form-anexosTab",
  data() {
    return {
      store,
      anexo_1: null,
      anexo_2: null,
      anexo_3: null,
      anexo_4: null,
      anexo_5: null,
      anexo_6: null,
      form: {
        anexo_1: null,
        anexo_2: null,
        anexo_3: null,
        anexo_4: null,
        anexo_5: null,
        anexo_6: null,
        remover_anexos: [],
      },
      fileInputs: {
        anexo_1: null,
        anexo_2: null,
        anexo_3: null,
        anexo_4: null,
        anexo_5: null,
        anexo_6: null,
      },
      tabCurrent: 7,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  components: {
    TrashCanIcon,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async setAnexo(event, anexo) {
      const data = await event.target.files[0];
      if (!data) return;

      this.removeFromRemovedList(anexo);
      this.revokeObjectUrl(this[anexo]);

      const url = URL.createObjectURL(data);
      this[anexo] = url;
      this.form[anexo] = data;
    },
    removeAnexo(anexo, refName) {
      this.revokeObjectUrl(this[anexo]);
      this[anexo] = null;
      this.form[anexo] = null;
      this.fileInputs[anexo] = null;

      if (this.$route.params.osData && this.$route.params.osData[anexo]) {
        this.addToRemovedList(anexo);
      }

      const fileInput = this.$refs[refName];
      if (fileInput?.reset) {
        fileInput.reset();
      }
    },
    addToRemovedList(anexo) {
      if (!this.form.remover_anexos.includes(anexo)) {
        this.form.remover_anexos.push(anexo);
      }
    },
    removeFromRemovedList(anexo) {
      this.form.remover_anexos = this.form.remover_anexos.filter(
        (anexoRemovido) => anexoRemovido !== anexo
      );
    },
    revokeObjectUrl(url) {
      if (url && url.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
    },
  },
  watch: {
    form: {
      handler(value) {
        this.store.formAnexos = value;
      },
      deep: true,
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { anexo_1, anexo_2, anexo_3, anexo_4, anexo_5, anexo_6 } =
        this.$route.params.osData;

      this.anexo_1 = anexo_1;
      this.form.anexo_1 = anexo_1;
      this.anexo_2 = anexo_2;
      this.form.anexo_2 = anexo_2;
      this.anexo_3 = anexo_3;
      this.form.anexo_3 = anexo_3;
      this.anexo_4 = anexo_4;
      this.form.anexo_4 = anexo_4;
      this.anexo_5 = anexo_5;
      this.form.anexo_5 = anexo_5;
      this.anexo_6 = anexo_6;
      this.form.anexo_6 = anexo_6;
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      if (store.trabalharHorasOs) {
        this.tabCurrent == 8;
      }
      return store.currentTab === this.tabCurrent;
    },
  },
};
